import React, {useEffect} from "react";
import UserParlaysContainer from "../UserParlaysContainer/UserParlaysContainer";
import {selectUserParlaysAllTime} from "../../stores/pickX/pickX.selectors";
import {useDispatch, useSelector} from "react-redux";
import './MyAllTime.style.scss';
import {useGetUserParlaysHistoryQuery} from "../../stores/pickX/pickX.api";
import moment from "moment/moment";
import {setSelectedParlayId} from "../../stores/pickX/pickX.slice";
import {useLocation} from "react-router-dom";

const pickXInceptionDate = moment("2024-11-01").toDate().toISOString();

const MyAllTime = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const allTimeUserParlays = useSelector(selectUserParlaysAllTime);
    const {isLoading} = useGetUserParlaysHistoryQuery(pickXInceptionDate);

    const queryParams = new URLSearchParams(location.search);
    const parlayId = queryParams.get("parlayId");

    useEffect(() => {
        if(parlayId) dispatch(setSelectedParlayId(parlayId));
        return () => {
            dispatch(setSelectedParlayId(null));
        };
    }, [parlayId]);

    return (
        <div className="MyAllTime">
            <UserParlaysContainer userParlays={allTimeUserParlays}/>
        </div>
    );
}

export default MyAllTime;